import {Component, Input, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material';
import {InsuranceDataModel} from '../../../../../../core/models/insurance-data.model';
import {VehicleModelStateService} from '../../../../../../core/services/impl/section-services/vehicle-model/vehicle-model-state.service';
import {NavigateManagerService} from '../../../../../../core/services/navigate-manager.service';
import {VehicleModelState} from '../../../../../states/vehicle-model.state';
import {VehicleDataModel} from '../../../../../../core/models/vehicle-data.model';
import {InsuranceDataStateService} from '../../../../../../core/services/impl/section-services/vehicle-data/insurance-data-state.service';
import {Ga4EventsConfigService} from '../../../../../../core/services/ga4-events-config.service';
import {Ga4OffersElementKey} from '../../../../../../core/consts/ga4-offers-element-key.enum';

@Component({
  selector: 'app-shortened-vehicle-info',
  templateUrl: './shortened-vehicle-info.component.html',
  styleUrls: ['./shortened-vehicle-info.component.scss']
})
export class ShortenedVehicleInfoComponent implements OnInit {

  @Input() context: 'OFFERS_LIST' | 'OFFERS_PRESENTATION';

  get offersElementKey(): Ga4OffersElementKey {
    switch (this.context) {
      case 'OFFERS_LIST':
        return Ga4OffersElementKey.EDIT_DATA_LIST;
      case 'OFFERS_PRESENTATION':
        return Ga4OffersElementKey.EDIT_DATA_COMPARISON;
      default:
        return null;
    }
  }

  get vehicleData(): VehicleDataModel {
    return this.vehicleModelStateService.vehicleData;
  }

  get vehicleModelState(): VehicleModelState {
    return this.vehicleModelStateService.vehicleModelState;
  }

  get insuranceData(): InsuranceDataModel {
    return this.insuranceDataStateService.insuranceData;
  }

  get showRegistrationNumber(): boolean {
    return this.vehicleData.registrationNumber !== this.vehicleModelStateService.unknownRegistrationNumberValue;
  }

  constructor(private vehicleModelStateService: VehicleModelStateService,
              private insuranceDataStateService: InsuranceDataStateService,
              private navigateManager: NavigateManagerService,
              private ga4EventsService: Ga4EventsConfigService,
              private dialog: MatDialog) { }

  ngOnInit() {
  }

  backToVehicleData() {
    this.dialog.closeAll();
    this.dialog.afterAllClosed.first().subscribe(() => this.navigateManager.moveToFirstStep());

    if (this.offersElementKey) {
      this.ga4EventsService.sendOffersElementEvent(this.offersElementKey);
    }
  }

}
